<template>
  <div class="my-10">
    <div class="flex flex-col sm:flex-row justify-between px-4 items-center">
      <h1 class="text-3xl font-bold text-center mb-4 sm:mb-0">{{ __("Consent forms") }}</h1>

      <inertia-link :href="route('consentForms.create')" class="btn-primary">
        {{ __("Add new consent form") }}
      </inertia-link>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 overflow-scroll">
      <table class="w-full" v-if="consentForms.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 w-10">{{ __("Id") }}</th>
          <th class="p-4 text-left">{{ __("Name") }}</th>
          <th class="p-4 text-left">{{ __("Dealership") }}</th>
          <th class="p-4 text-right w-24">{{ __("Actions") }}</th>
        </tr>

        <tr v-for="(form, index) in consentForms.data" :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 text-center">{{ form.id }}</td>
          <td class="p-4">
            <inertia-link :href="route('consentForms.edit', {consentForm: form.id})" class="text-coral-400 hover:text-gray-500 font-semibold">
              {{ form.name }}
            </inertia-link>
          </td>
          <td class="p-4">{{ form.dealership_name }}</td>
          <td class="px-4 text-center">
            <div class="flex items-center w-full justify-end">
              <inertia-link :href="route('consentForms.edit', {consentForm: form.id})" class="list-edit-button mr-2">
                <icon name="edit" class="w-4 h-4 fill-current"></icon>
              </inertia-link>
              <button @click="destroy(form)" class="list-delete-button">
                <icon name="delete" class="w-4 h-4 fill-current"></icon>
              </button>
            </div>
          </td>
        </tr>
      </table>

      <div v-else>
        {{ __("No consent forms at the moment...") }}
      </div>
    </div>

    <pagination :links="consentForms.meta.links"/>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';
  import Pagination from '@/Shared/Pagination';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Consent forms")
      }
    },
    props: {
      consentForms: Object,
    },
    components: {
      Layout,
      Pagination,
      Icon,
    },
    methods: {
      destroy(form) {
        if (confirm(this.__("Are you sure you want to delete :name?", {name: form.name}))) {
          this.$inertia.delete(this.route('consentForms.destroy', {consentForm: form.id}));
        }
      }
    }
  }
</script>
